export default __webpack_public_path__ + "static/poshpads-logo-beef8c30f91fef75759775113ba3833c.jpeg";